import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { EventsListApiResponse } from '../types/events.types';

import { getEventsListService } from 'services/events.service';

import { EVENTS_CACHE_KEYS, USE_MOCK_DATA } from '../constants';
import { getMockLatestEvents } from '../mocks/events.mock';

const HIGHLIGHTED_EVENTS_COUNT = 5;

export const useHighlightedEvents = () => {
  const { data, isLoading, isError, error } = useQuery<AxiosResponse<EventsListApiResponse>>({
    queryKey: [EVENTS_CACHE_KEYS.HIGHLIGHTED_EVENTS],
    queryFn: ({ signal }) => {
      if (USE_MOCK_DATA) {
        const mockEvents = getMockLatestEvents(HIGHLIGHTED_EVENTS_COUNT);
        return Promise.resolve({
          data: {
            count: mockEvents.length,
            next: null,
            previous: null,
            results: mockEvents,
          },
          status: 200,
          statusText: 'OK',
          headers: {},
          config: {} as any,
        } as AxiosResponse<EventsListApiResponse>);
      }

      return getEventsListService(
        {
          highlighted: true,
        },
        signal!
      );
    },
    staleTime: 5 * 60 * 1000, // 5 minutes - highlighted events don't change frequently
  });

  const events = data?.data.results ?? [];

  return {
    events,
    isLoading,
    isError,
    error,
  };
};
